import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { catchError, filter, map, Observable, of, switchMap, take } from 'rxjs';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { User } from 'src/app/shared/models/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ConsentGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(): Observable<boolean> {
    return this.authService.getActiveUser().pipe(
      filter((user: User | null) => user !== null),
      take(1),
      switchMap((user: User) => {
        if (user.hasGivenConsent === true) {
          return of(true);
        } else {
          this.router.navigate(['/dashboard']);
          return of(false);
        }
      })
    );
  }
}
